/// <summary>
/// 화재 시 동작 방법
/// </summary>
export enum EOperationOnFire {
  /// <summary>
  /// 동작 없음
  /// </summary>
  DONT_CARE,
  /// <summary>
  /// 열기
  /// </summary>
  OPEN,
  /// <summary>
  /// 폐쇄
  /// </summary>
  CLOSE
}
